// Customer's choice per product form. The block is re-rendered on variant change, so we keep what the customer
// selected instead of going back to the block "Default state" setting
const selectedStates = new Map();

class GiftWrappingBlock extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-gift-wrapping-toggle]');
    this.fields = Array.from(this.querySelectorAll('[data-gift-wrapping-field]'));

    if (this.toggle && selectedStates.has(this.formId)) {
      this.toggle.checked = selectedStates.get(this.formId);
    }

    this.onToggleChange = this.onToggleChange.bind(this);
    this.toggle?.addEventListener('change', this.onToggleChange);

    this.updateFields();
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('change', this.onToggleChange);
  }

  get formId() {
    return this.getAttribute('form-id');
  }

  onToggleChange() {
    selectedStates.set(this.formId, Boolean(this.toggle?.checked));
    this.updateFields();
  }

  updateFields() {
    const enabled = Boolean(this.toggle?.checked);
    this.fields.forEach((field) => {
      field.disabled = !enabled;
    });
  }
}

if (!customElements.get('gift-wrapping-block')) {
  customElements.define('gift-wrapping-block', GiftWrappingBlock);
}
